import SelectOptions from "./select-options";

const viewType = {
  GRID: "GRID",
  LIST: "LIST"
}

const categories = {
  ALL_CATEGORIES_NAME: "All categories",
  ALL_CATEGORIES_KEY: "all"
}

export default {
  selectOptions: SelectOptions,
  viewType,
  categories
};
